const toNumericVersion = (v) => {
    if (typeof v === 'number') {
        return Number.isFinite(v) ? v : 0;
    }
    const parsed = parseInt(v || '0', 10);
    return Number.isFinite(parsed) ? parsed : 0;
};
export const deduplicateResourcesByKey = (items) => {
    const latestByKey = new Map();
    const withoutKey = [];
    for (const item of items) {
        if (!item.key) {
            withoutKey.push(item);
            continue;
        }
        const existing = latestByKey.get(item.key);
        if (!existing || toNumericVersion(item.version) > toNumericVersion(existing.version)) {
            latestByKey.set(item.key, item);
        }
    }
    return [...latestByKey.values(), ...withoutKey];
};
